import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import {
	CompanyTransactionListResult,
	CompanyTransactionsState,
} from '@localTypes/companyTransactions';

const initialState: CompanyTransactionsState = {};

export const companyTransactionsSlice = createSlice({
	initialState,
	name: 'company_transactions',
	reducers: {
		clearAllCompanyTransactions: () => ({}),
		clearCompanyTransactions: (state, action: PayloadAction<number>) => {
			const companyId = action.payload;
			delete state[companyId];
		},
		setCompanyTransactions: (state, action: PayloadAction<{
			companyId: number;
			result: CompanyTransactionListResult['result'];
			total: number;
		}>) => {
			const {
				companyId,
				result,
				total,
			} = action.payload;
			state[companyId] = {
				isError: false,
				isLoading: false,
				result,
				total,
			};
		},
		setCompanyTransactionsError: (state, action: PayloadAction<{
			companyId: number;
			isError: boolean;
		}>) => {
			const {
				companyId,
				isError,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isError = isError;
		},
		setCompanyTransactionsLoading: (state, action: PayloadAction<{
			companyId: number;
			isLoading: boolean;
		}>) => {
			const {
				companyId,
				isLoading,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isLoading = isLoading;
		},
	},
});

export const {
	clearAllCompanyTransactions,
	clearCompanyTransactions,
	setCompanyTransactions,
	setCompanyTransactionsError,
	setCompanyTransactionsLoading,
} = companyTransactionsSlice.actions;

export const companyTransactionsReducer = companyTransactionsSlice.reducer;
